import icChevLeft from 'assets/images/ic-chevron-left.svg'
import icDocumentImportSuccess from "assets/images/ic-document-import-succes.svg"
import icUploadGrey from 'assets/images/ic-upload-grey.svg'
import icError from 'assets/images/ic-error.svg'
import icUploadWhite from 'assets/images/ic-upload-white.svg'
import { Alert } from "components/commons/alert"
import Button from 'components/commons/button'
import Table from 'components/commons/table'
import { useState } from 'react'
import { capitalize } from 'utils/utils.js'
import { useImport } from '../ImportContext.jsx'

export const ViewData = () => {
    const { details, columnTableView, columnNameMapping, validateData, setActiveStep } = useImport()
    const [currentPage, setCurrentPage] = useState(1)
    const isValidated = !validateData?.statistics?.total_invalid

    const errorMessage = (data = []) => {
        let message = ''
        data?.forEach((item) => {
            message += `\nTerjadi error pada baris ${item?.excel_row} excel\n`
            item?.errors?.map((item) => {
                const displayName = columnNameMapping[item?.column_name] || item?.column_name
                let errorMsg = item?.message
                Object.entries(columnNameMapping).forEach(([key, value]) => {
                    errorMsg = errorMsg?.replaceAll(key?.replaceAll('_', ' '), value?.replaceAll('_', ' '))
                })
                return (message += `- ${capitalize(displayName?.replaceAll('_', ' '))}: ${errorMsg}\n`)
            })
        })

        return message
    }

    const showErrorDetail = () => {
        Alert({
            icon: 'error',
            title: 'Error Validate',
            titleClassName: 'text-center',
            message: errorMessage(validateData?.data),
        })
    }

    const newTableView = columnTableView?.map((item) => {
        if (details[item?.key]) return { ...item, render: () => details[item?.key]?.value }
        return item
    })

    const onBackToStep = async () => {
        return Alert({
            title: <p className='text-center'>Confirmation</p>,
            message: <p>Unsaved data will be lost. Are you sure you want to go back to Step 1?</p>,
            buttonConfirmText: 'Oke',
            buttonCloseText: 'Cancel',
            backdrop: false,
            icon: 'warning',
        }).then((isConfirm) => {
            if (isConfirm) setActiveStep(1)
        })
    }

    return (
        <div className='flex flex-col space-y-6 w-full px-6'>
            {validateData?.statistics?.total_invalid > 0 ? 
                <>
                    <div className='flex justify-between items-center'>
                        <p className='font-semibold text-md text-neutral-80'>
                            Total Data
                            <span className='font-bold text-base text-primary-50 ml-2'>
                                {validateData?.statistics?.total_invalid || validateData?.statistics?.total || 0}
                            </span>
                        </p>
                        <Button
                            type='outline'
                            title='Error Detail'
                            icon={icError}
                            disabled={isValidated}
                            onClick={showErrorDetail}
                        />
                    </div>
                    <Table
                        name=''
                        data={validateData?.data?.slice(10 * (currentPage - 1), currentPage * 10)}
                        columns={newTableView}
                        size={10}
                        totalPage={Math.ceil(validateData?.statistics?.total_invalid / 10)}
                        totalResult=' '
                        onChangePage={(page) => setCurrentPage(page)}
                        emptyMessage='All Data is Valid'
                    />
                </>
                : 
                <div className="w-full">
                    <div className={"flex flex-col items-center justify-center px-40 py-16"}>
                        <p className="font-bold">Success Validate Data</p>
                        <img src={icDocumentImportSuccess} alt="ic-document-import-success" className="mx-auto"/>
                    </div>
                </div>
        
            }

            <div className='flex justify-end items-center gap-3'>
                <Button type='outline' className='w-fit' title='Back' icon={icChevLeft} onClick={onBackToStep} />
                <Button
                    title='Import Data'
                    icon={isValidated ? icUploadWhite : icUploadGrey}
                    onClick={() => setActiveStep(4)}
                    disabled={!isValidated}
                />
            </div>
        </div>
    )
}
